module.exports = __webpack_public_path__ + "static/media/noise-map.20a744c6.jpg";